<div class="preview-container" *ngIf="channelTypeImg">
  <div
    class="close"
    (click)="bsModalRef.hide()"
    (keyDown)="$event.preventDefault()"
  >
    <img src="{{ icons.CLOSE }}" alt="Close" />
  </div>
  <h2>{{ title }}</h2>
  <div class="preview-modal-body">
    <img src="{{ channelTypeImg }}" alt="Channel_Type" />
    <div
      class="preview"
      *ngIf="
        channelType !== previewCase.RCS &&
        channelType !== previewCase.PUSH_NOTIFICATION
      "
    >
      <app-template-preview
        [channel]="channelType"
        [mediaURL]="mediaURL"
        [content]="content"
        [footer]="footer"
        [ctaButtons]="ctaButtons"
        [isCarousel]="isCarousel"
        [carouselCards]="carouselCards"
      ></app-template-preview>
    </div>
    <div class="preview" *ngIf="channelType === previewCase.RCS">
      <app-rcs-template-preview
        [mediaURL]="mediaURL"
        [formData]="formData"
        [content]="content"
        [ctaButtons]="ctaButtons"
        [isCarousel]="isCarousel"
        [carouselCards]="carouselCards"
        [isCalledFromCreation]="false"
        [activeForm]="activeForm"
      ></app-rcs-template-preview>
    </div>
    <div class="preview" *ngIf="channelType === previewCase.PUSH_NOTIFICATION">
      <app-push-notification-template-preview
        [formData]="formData"
        [isCalledFromCreation]="false"
      ></app-push-notification-template-preview>
    </div>
    <p
      class="dynamic-cta-warning text-center"
      *ngIf="
        channelType !== previewCase.PUSH_NOTIFICATION &&
        channelType !== previewCase.SMS
      "
    >
      Dynamic CTA URLs won't work as they lack a dynamic component
    </p>
  </div>
  <div class="preview-modal-footer">
    <button class="btn-back" (click)="bsModalRef.hide()">Back</button>
  </div>
</div>
